import * as React from 'react'

///////////////////////////////////////////////////////////////////////////////

export const IconSpinner = () => (
  <svg
    className="icon-spinner"
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 100 100"
    focusable="false"
  >
    <defs>
      <clipPath id="cut-off">
        <rect x="0" y="50" width="100" height="100" />
      </clipPath>
      <linearGradient id="gradient">
        <stop className="icon-spinner-stop" offset="0" stopColor="#000" />
        <stop
          className="icon-spinner-stop"
          offset="100%"
          stopColor="#000"
          stopOpacity="0"
        />
      </linearGradient>
    </defs>
    <circle
      className="icon-spinner-circle"
      cx="50"
      cy="50"
      r="40"
      fill="none"
      strokeWidth="8"
      stroke="url(#gradient)"
      clipPath="url(#cut-off)"
    />
  </svg>
)

export const IconClose = () => (
  <svg
    className="icon-close"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    focusable="false"
  >
    <path
      className="icon-close-inner"
      fillRule="evenodd"
      d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11C21.993 4.928 17.072.007 11 0zm0 20.625A9.625 9.625 0 1 1 20.625 11 9.635 9.635 0 0 1 11 20.625zm3.924-13.549a.688.688 0 0 0-.973 0L11 10.028 8.049 7.076a.688.688 0 0 0-.973.973L10.028 11l-2.952 2.951a.687.687 0 1 0 .973.973L11 11.972l2.951 2.952a.688.688 0 0 0 .973-.973L11.972 11l2.952-2.951a.688.688 0 0 0 0-.973z"
    />
  </svg>
)

export const IconPlus = () => (
  <svg
    className="icon-plus"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    focusable="false"
  >
    <path
      className="icon-plus-inner"
      fillRule="evenodd"
      d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11C21.993 4.928 17.072.007 11 0zm0 20.625A9.625 9.625 0 1 1 20.625 11 9.635 9.635 0 0 1 11 20.625zm4.125-10.313h-3.438V6.876a.687.687 0 1 0-1.374 0v3.438H6.874a.687.687 0 1 0 0 1.374h3.438v3.438a.687.687 0 1 0 1.374 0v-3.438h3.438a.687.687 0 1 0 0-1.374z"
    />
  </svg>
)

export const IconMinus = () => (
  <svg
    className="icon-minus"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    focusable="false"
  >
    <path
      className="icon-minus-inner"
      fillRule="evenodd"
      d="M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11C21.993 4.928 17.072.007 11 0zm0 20.625A9.625 9.625 0 1 1 20.625 11 9.635 9.635 0 0 1 11 20.625zm4.125-10.313h-8.25a.687.687 0 1 0 0 1.376h8.25a.687.687 0 1 0 0-1.376z"
    />
  </svg>
)

export const IconInfo = () => (
  <svg
    className="icon-info"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    focusable="false"
  >
    <g className="icon-info-inner" fillRule="nonzero">
      <path d="M8.15 5a.85.85 0 1 1 1.7 0v.5a.85.85 0 1 1-1.7 0V5zM8.15 8.472a.85.85 0 1 1 1.7 0V13a.85.85 0 0 1-1.7 0V8.472z" />
      <path d="M9 16.3A7.3 7.3 0 1 0 9 1.7a7.3 7.3 0 0 0 0 14.6zM9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18z" />
    </g>
  </svg>
)

export const IconAngleLeft = () => (
  <svg
    className="icon-angle-left"
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="19"
    viewBox="0 0 12 19"
    focusable="false"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
    >
      <g
        className="icon-angle-left-inner"
        transform="translate(-54.000000, -355.000000)"
        stroke="#D3D3D3"
        strokeWidth="2"
      >
        <g transform="translate(31.000000, 31.000000)">
          <g transform="translate(0.000000, 301.000000)">
            <polyline
              transform="translate(33.485281, 32.485281) rotate(-315.000000) translate(-33.485281, -32.485281)"
              points="39.4852814 38.4852814 27.4852814 38.4852814 27.4852814 26.4852814"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export const IconDownload = () => (
  <svg
    className="icon-download"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    focusable="false"
  >
    <g className="icon-download-inner" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M15 28c7.18 0 13-5.82 13-13S22.18 2 15 2 2 7.82 2 15s5.82 13 13 13zm0 1.7C6.881 29.7.3 23.119.3 15S6.881.3 15 .3 29.7 6.881 29.7 15 23.119 29.7 15 29.7z"
      />
      <path d="M20.738 14.751l-4.66 4.55V8.455a.78.78 0 0 0-.216-.555.822.822 0 0 0-.568-.21.752.752 0 0 0-.548.21.746.746 0 0 0-.235.555v10.863l-4.68-4.568a.796.796 0 0 0-.548-.21.72.72 0 0 0-.548.23.725.725 0 0 0-.235.534c0 .217.078.395.235.536l5.933 5.772a.22.22 0 0 0 .078.076l.196.134a.663.663 0 0 0 .352.096l.118-.02a.596.596 0 0 0 .254-.076l.196-.134 5.992-5.848a.716.716 0 0 0 .215-.536.78.78 0 0 0-.215-.554.822.822 0 0 0-.568-.21.752.752 0 0 0-.548.21z" />
    </g>
  </svg>
)

export const IconOk = () => (
  <svg
    className="icon-ok"
    xmlns="http://www.w3.org/2000/svg"
    width="54"
    height="54"
    viewBox="0 0 54 54"
    focusable="false"
  >
    <g className="icon-ok-inner" fillRule="evenodd">
      <path
        fillRule="evenodd"
        d="M23.937 33.036l-7.562-7.56a1.688 1.688 0 1 0-2.386 2.386l8.775 8.775c.317.317.746.495 1.193.495a1.69 1.69 0 0 0 1.202-.507l14.85-15.187a1.688 1.688 0 1 0-2.403-2.37L23.937 33.037zM27 0C12.088 0 0 12.088 0 27s12.088 27 27 27 27-12.088 27-27C53.982 12.096 41.904.018 27 0zm0 50.625C13.952 50.625 3.375 40.048 3.375 27S13.952 3.375 27 3.375 50.625 13.952 50.625 27C50.611 40.042 40.042 50.611 27 50.625z"
      />
    </g>
  </svg>
)

export const IconLock = () => (
  <svg
    className="icon-lock"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="25"
    viewBox="0 0 20 25"
    focusable="false"
  >
    <g className="icon-lock-inner" fillRule="evenodd">
      <g fill="none" fillRule="evenodd">
        <path
          className="lock-stroke1"
          stroke="#444"
          strokeWidth="1.7"
          d="M15.76 8.85H4.21c-1.845 0-3.36 1.524-3.36 3.385v8.53c0 1.861 1.515 3.385 3.36 3.385h11.58c1.845 0 3.36-1.524 3.36-3.385v-8.52c-.024-1.882-1.529-3.395-3.39-3.395z"
        />
        <path
          className="lock-path1"
          fill="#444"
          fillRule="nonzero"
          d="M15.3 7.412c0-3.02-2.353-5.512-5.3-5.512-2.947 0-5.3 2.491-5.3 5.512 0 .262.021.482.08.736l10.48.01c.028-.224.04-.464.04-.746zM16.5 9.5L3.617 9.488C3.26 8.598 3 8.441 3 7.412 3 3.318 6.134 0 10 0s7 3.318 7 7.412c0 1.034-.139 1.194-.5 2.088z"
        />
        <path
          className="lock-stroke2"
          stroke="#444"
          strokeLinecap="round"
          strokeWidth="1.7"
          d="M10 16v2.583"
        />
      </g>
    </g>
  </svg>
)

export const IconHeart = () => (
  <svg
    className="icon-heart"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="19"
    viewBox="0 0 22 19"
    focusable="false"
  >
    <g className="icon-heart-inner" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M11.004 4.427l-3.457-2.56a4.045 4.045 0 0 0-1.91-.115c-1.314.237-2.312.93-3.048 2.13-1.084 1.766-1.163 3.304-.31 4.798.555.973 1.285 1.934 2.239 2.94 1.746 1.843 3.81 3.605 6.48 5.526 2.425-1.74 4.339-3.345 6.013-5.04 1.273-1.287 2.104-2.31 2.736-3.492.385-.718.565-1.265.552-1.793-.042-1.752-.714-3.137-2.044-4.227a4.067 4.067 0 0 0-2.578-.902c-.43 0-.859.067-1.266.194l-3.407 2.54zM9.237 1.013l1.764 1.306 1.759-1.312-.125-.165a5.945 5.945 0 0 1 3.042-.837c1.349 0 2.65.457 3.662 1.289 1.711 1.402 2.606 3.248 2.66 5.486.024 1.04-.389 1.95-.752 2.627-.846 1.583-2.003 2.85-3.022 3.882-1.826 1.847-3.915 3.584-6.574 5.469-.108.08-.327.242-.65.242a1.02 1.02 0 0 1-.6-.202c-2.948-2.09-5.21-4.005-7.121-6.022-1.044-1.1-1.855-2.169-2.48-3.264-1.17-2.049-1.056-4.238.337-6.508.986-1.608 2.4-2.588 4.197-2.912a5.785 5.785 0 0 1 4.03.752l-.127.17z"
      />
    </g>
  </svg>
)

export const IconWarning = () => (
  <svg
    className="icon-warning"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    focusable="false"
  >
    <g className="icon-warning-inner" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M13.039 16.889a1.039 1.039 0 0 1-2.078 0v-.611a1.039 1.039 0 0 1 2.078 0v.61zM13.039 12.645a1.039 1.039 0 1 1-2.078 0V7.111a1.039 1.039 0 1 1 2.078 0v5.534z" />
        <path d="M12 1.85C6.394 1.85 1.85 6.394 1.85 12c0 5.606 4.544 10.15 10.15 10.15 5.606 0 10.15-4.544 10.15-10.15 0-5.606-4.544-10.15-10.15-10.15zm0-1.7C18.545.15 23.85 5.455 23.85 12S18.545 23.85 12 23.85.15 18.545.15 12 5.455.15 12 .15z" />
      </g>
    </g>
  </svg>
)

export const IconCard = () => (
  <svg
    className="icon-card"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="17"
    viewBox="0 0 22 17"
    focusable="false"
  >
    <g className="icon-card-inner" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M2 1.7a.3.3 0 0 0-.3.3v13a.3.3 0 0 0 .3.3h18a.3.3 0 0 0 .3-.3V2a.3.3 0 0 0-.3-.3H2zM2 0h18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" />
        <path d="M.65 6.85v-1.7h21.206v1.7zM11 11.85a.85.85 0 0 1 0-1.7h5.5a.85.85 0 0 1 0 1.7H11zM6 11.85a.85.85 0 0 1 0-1.7h2a.85.85 0 0 1 0 1.7H6z" />
      </g>
    </g>
  </svg>
)

export const IconPerson = () => (
  <svg
    className="icon-person"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    focusable="false"
  >
    <g className="icon-person-inner" fillRule="evenodd">
      <g fillRule="nonzero">
        <path d="M20.715 19.515a.85.85 0 0 1-1.43.918c-1.804-2.81-5.116-4.583-8.777-4.583-3.67 0-6.991 1.783-8.791 4.607a.85.85 0 0 1-1.434-.914C2.4 16.225 6.262 14.15 10.508 14.15c4.234 0 8.088 2.062 10.207 5.365zM10.5 10.85a5.35 5.35 0 1 1 0-10.7 5.35 5.35 0 0 1 0 10.7zm0-1.7a3.65 3.65 0 1 0 0-7.3 3.65 3.65 0 0 0 0 7.3z" />
      </g>
    </g>
  </svg>
)

export const IconMobile = () => (
  <svg
    className="icon-mobile"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="25"
    viewBox="0 0 16 25"
    focusable="false"
  >
    <g className="icon-mobile-inner" fillRule="evenodd">
      <path
        fillRule="nonzero"
        d="M2 1.7a.3.3 0 0 0-.3.3v21a.3.3 0 0 0 .3.3h12a.3.3 0 0 0 .3-.3V2a.3.3 0 0 0-.3-.3H2zM2 0h12a2 2 0 0 1 2 2v21a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z"
      />
      <circle cx="8" cy="19.5" r="1.5" />
      <path fillRule="nonzero" d="M.65 6.35v-1.7h13.866v1.7z" />
    </g>
  </svg>
)

export const IconNoSMS = () => (
  <svg
    className="icon-nosms"
    xmlns="http://www.w3.org/2000/svg"
    width="220"
    height="220"
    viewBox="0 0 220 220"
    focusable="false"
  >
    <g className="icon-nosms-inner" fillRule="evenodd">
      <defs>
        <circle id="a" cx="110" cy="110" r="110" />
        <linearGradient id="b" x1="46.681%" x2="50%" y1="54.21%" y2="2.553%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="100%" stopOpacity=".15" />
        </linearGradient>
        <path id="d" d="M.316 120.286H64.86V.431H.316z" />
        <path id="f" d="M.01.618h64.518v126.13H.01z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="c" fill="#fff">
          <circle id="a" cx="110" cy="110" r="110" />
        </mask>
        <circle fill="#F1F1F1" id="a" cx="110" cy="110" r="110" />
        <path
          fill="url(#b)"
          d="M-24 57.951h156.558V214.51H-24z"
          mask="url(#c)"
          transform="rotate(60 54.279 136.23)"
        />
        <g mask="url(#c)">
          <path
            fill="#E3B89C"
            d="M82.552 164.977l-5.178 9.66s-.568.455-1.569 1.058l7.848 1.073-2.07 15.157s-3.146 9.097-11.751 9.826c-.627.053-2.435.287-2.493-.341-.525-5.6.557-17.098 1.19-22.992-1.898.302-3.995.313-6.179-.224-.616-.152-2.326-.828-2.098-1.415 2.814-7.232 6.62-22.711 7.24-23.309 2.545-2.445 10.786-2.64 16.516-2.451l34.03-55.762s47.217 35.846 54.185 47.576c3.14 5.287 6.663 70.755 11.136 94.653 3.022 16.146 18.176 65.516 18.176 65.516l-39.668-1.467s-17.588-47.266-20.108-53.4c-5.766-14.039-13.035-27.291-13.035-27.291-23.656-12.529-39.848-42.447-46.172-55.867zM69.446 145.29c-3.3.346-8.184 1.214-13.118-4.53-.375-.436-1.28-1.839-.798-2.154 5.946-3.884 17.808-13.48 17.808-13.48l10.453-1.047 7.217 11.257s-15.548 9.324-21.562 9.954zm-1.717-66.392c4.487-7.805 14.793-.43 24.546 5.744 1.904 1.206 5.895 6.834 5.895 6.834l-8.087 13.84S62.21 88.498 67.73 78.897z"
          />
          <path
            fill="#444"
            d="M135.142 186.097c5.46 0 9.905-4.37 9.905-9.741V39.701c0-5.37-4.444-9.741-9.905-9.741H82.874c-5.46 0-9.904 4.371-9.904 9.74v136.656c0 3.62 2.018 6.784 5.005 8.464a9.971 9.971 0 0 0 4.9 1.277h52.267z"
          />
          <path
            fill="#E3E3E3"
            d="M116.122 172.01h-13.634a3.094 3.094 0 0 0-3.085 3.103 3.094 3.094 0 0 0 3.085 3.103h13.634a3.094 3.094 0 0 0 3.085-3.103 3.094 3.094 0 0 0-3.085-3.104"
          />
          <g transform="translate(76.683 45.133)">
            <mask id="e" fill="#fff">
              <path id="d" d="M.316 120.286H64.86V.431H.316z" />
            </mask>
            <path fill="#FFF" id="d" d="M.316 120.286H64.86V.431H.316z" />
            <g mask="url(#e)">
              <g transform="translate(.554 -3.364)">
                <mask id="g" fill="#fff">
                  <path id="f" d="M.01.618h64.518v126.13H.01z" />
                </mask>
                <path fill="#F7F7F7" id="f" d="M.01.618h64.518v126.13H.01z" />
                <g mask="url(#g)">
                  <path
                    fill="#C7C7C7"
                    d="M51.82 52.337H12.263L8.205 55.38v26.118h47.672V55.38l-4.057-3.043"
                  />
                  <path fill="#FFF" d="M10.488 37.63h43.107v35.5H10.488z" />
                  <path
                    className="question-mark"
                    fill="#444"
                    d="M30.412 57.403c.008-1.117.137-1.916.387-2.396s.805-1.084 1.664-1.81c.61-.595 1.094-1.163 1.453-1.706a3.19 3.19 0 0 0 .54-1.799c0-.758-.206-1.346-.616-1.764-.41-.417-.994-.626-1.752-.626-.648 0-1.2.177-1.652.533-.453.355-.68.88-.68 1.576h-2.742l-.035-.07c-.024-1.391.443-2.475 1.4-3.252.957-.778 2.193-1.166 3.71-1.166 1.64 0 2.919.418 3.837 1.254.918.835 1.377 1.996 1.377 3.48 0 .992-.287 1.912-.861 2.76a10.665 10.665 0 0 1-2.174 2.326c-.446.39-.725.762-.838 1.113-.113.352-.17.867-.17 1.547h-2.848zm2.895 4.828H30.4v-2.73h2.906v2.73z"
                  />
                  <path
                    fill="#E2E2E2"
                    d="M56.638 55.38v31.696H8.966L56.638 55.38"
                  />
                  <path fill="#EFEFEF" d="M7.952 87.076h47.671L7.952 55.38z" />
                </g>
              </g>
            </g>
          </g>
          <path
            fill="#FCCFB2"
            d="M112.078 122.497c1.169 3.883 7.783 11.036 9.844 12.852 2.774 2.444 12.964 10.016 18.062 12.487 0 0 3.393 13.53-1.55 25.334-3.35 7.997-3.442 23.677.385 34.552.634 1.801 8.441 16.395 12.417 25.956 11.372 27.347 24.655 68.427 24.655 68.427l45.968 1.864s-17.512-33.68-27.685-56.097c-12.621-27.807-14.539-41.467-15.126-49.024-.87-11.21-3.646-35.583-4.486-38.74-1.128-4.239-3.753-8.149-5.92-10.96-6.791-8.804-15.21-21.445-22.973-23.947-11.213-3.612-24.429-12.466-24.429-12.466s-14.355-7.487-9.162 9.762"
          />
        </g>
      </g>
    </g>
  </svg>
)

export const IconSMSCountdown = () => (
  <svg
    className="icon-sms"
    xmlns="http://www.w3.org/2000/svg"
    width="296"
    height="232"
    viewBox="0 0 296 232"
    focusable="false"
  >
    <g className="icon-sms-inner" fillRule="evenodd">
      <defs>
        <circle id="a" cx="110" cy="110" r="110" />
        <linearGradient id="b" x1="46.681%" x2="50%" y1="54.21%" y2="2.553%">
          <stop offset="0%" stopColor="#FFF" stopOpacity="0" />
          <stop offset="100%" stopOpacity=".15" />
        </linearGradient>
        <path id="d" d="M.316 120.286H64.86V.431H.316z" />
        <path id="e" d="M.564-2.747h64.518v126.13H.564z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(76 12)">
          <mask id="c" fill="#fff">
            <circle id="a" cx="110" cy="110" r="110" />
          </mask>
          <circle fill="#F1F1F1" id="a" cx="110" cy="110" r="110" />
          <path
            fill="url(#b)"
            d="M-24 58.951h156.558V215.51H-24z"
            mask="url(#c)"
            transform="rotate(60 54.279 137.23)"
          />
          <path
            fill="#E3B89C"
            d="M82.552 164.977l-5.178 9.66s-.568.455-1.569 1.058l7.848 1.073-2.07 15.157s-3.146 9.097-11.751 9.826c-.627.053-2.435.287-2.493-.341-.525-5.6.557-17.098 1.19-22.992-1.898.302-3.995.313-6.179-.224-.616-.152-2.326-.828-2.098-1.415 2.814-7.232 6.62-22.711 7.24-23.309 2.545-2.445 10.786-2.64 16.516-2.451l34.03-55.762s47.217 35.846 54.185 47.576c3.14 5.287 6.663 70.755 11.136 94.653 3.022 16.146 18.176 65.516 18.176 65.516l-39.668-1.467s-17.588-47.266-20.108-53.4c-5.766-14.039-13.035-27.291-13.035-27.291-23.656-12.529-39.848-42.447-46.172-55.867zM69.446 145.29c-3.3.346-8.184 1.214-13.118-4.53-.375-.436-1.28-1.839-.798-2.154 5.946-3.884 17.808-13.48 17.808-13.48l10.453-1.047 7.217 11.257s-15.548 9.324-21.562 9.954zm-1.717-66.392c4.487-7.805 14.793-.43 24.546 5.744 1.904 1.206 5.895 6.834 5.895 6.834l-8.087 13.84S62.21 88.498 67.73 78.897z"
            mask="url(#c)"
          />
          <g mask="url(#c)">
            <path
              fill="#444"
              d="M135.142 186.097c5.46 0 9.905-4.37 9.905-9.741V39.701c0-5.37-4.444-9.741-9.905-9.741H82.874c-5.46 0-9.904 4.371-9.904 9.74v136.656c0 3.62 2.018 6.784 5.005 8.464a9.971 9.971 0 0 0 4.9 1.277h52.267z"
            />
            <path
              fill="#E3E3E3"
              d="M116.122 172.01h-13.634a3.094 3.094 0 0 0-3.085 3.103 3.094 3.094 0 0 0 3.085 3.103h13.634a3.094 3.094 0 0 0 3.085-3.103 3.094 3.094 0 0 0-3.085-3.104"
            />
          </g>
          <g mask="url(#c)">
            <g transform="translate(76.683 45.133)">
              <path fill="#FFF" id="d" d="M.316 120.286H64.86V.431H.316z" />
              <mask id="f" fill="#fff">
                <path id="e" d="M.564-2.747h64.518v126.13H.564z" />
              </mask>
              <path fill="#F7F7F7" id="e" d="M.564-2.747h64.518v126.13H.564z" />
              <g mask="url(#f)">
                <path
                  fill="#C7C7C7"
                  d="M52.373 48.973H12.816L8.76 52.016v26.118h47.672V52.016l-4.058-3.043"
                />
                <path fill="#FFF" d="M11.041 34.266h43.107v35.5H11.041z" />
                <path
                  fill="#E2E2E2"
                  d="M19.406 43.1c0-.56.463-1.015 1.013-1.015h24.646c.56 0 1.013.45 1.013 1.015a1.02 1.02 0 0 1-1.013 1.014H20.419c-.56 0-1.013-.45-1.013-1.014zM19.406 48.171c0-.56.463-1.014 1.013-1.014h24.646c.56 0 1.013.45 1.013 1.014a1.02 1.02 0 0 1-1.013 1.014H20.419c-.56 0-1.013-.45-1.013-1.014zM19.406 53.243c0-.56.463-1.015 1.013-1.015h24.646c.56 0 1.013.45 1.013 1.015a1.02 1.02 0 0 1-1.013 1.014H20.419c-.56 0-1.013-.45-1.013-1.014zM57.191 52.016v31.696H9.52L57.19 52.016"
                />
                <path fill="#EFEFEF" d="M8.505 83.712h47.672L8.505 52.016z" />
              </g>
              <g mask="url(#f)">
                <g transform="translate(49.077 47.959)">
                  <circle
                    className="number-of-letters"
                    cx="6.086"
                    cy="6.086"
                    r="6.086"
                    fill="#444"
                  />
                  <path
                    fill="#FFF"
                    d="M6.985 9.14H5.861V4.526h-1.14v-.793l2.264-.2z"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            fill="#FCCFB2"
            d="M112.078 122.497c1.169 3.883 7.783 11.036 9.844 12.852 2.774 2.444 12.964 10.016 18.062 12.487 0 0 3.393 13.53-1.55 25.334-3.35 7.997-3.442 23.677.385 34.552.634 1.801 8.441 16.395 12.417 25.956 11.372 27.347 24.655 68.427 24.655 68.427l45.968 1.864s-17.512-33.68-27.685-56.097c-12.621-27.807-14.539-41.467-15.126-49.024-.87-11.21-3.646-35.583-4.486-38.74-1.128-4.239-3.753-8.149-5.92-10.96-6.791-8.804-15.21-21.445-22.973-23.947-11.213-3.612-24.429-12.466-24.429-12.466s-14.355-7.487-9.162 9.762"
            mask="url(#c)"
          />
        </g>
        <path
          className="sms-bubble"
          fill="#444"
          d="M84.14 98.416l16.45 16.503V94.012C117.37 86.168 129 69.097 129 49.3 129 22.073 106.998 0 79.857 0H49.143C22.002 0 0 22.073 0 49.3c0 27.228 22.002 49.3 49.143 49.3h30.714c1.443 0 2.871-.062 4.282-.184z"
        />
      </g>
    </g>
  </svg>
)
